export default __webpack_public_path__ + "static/media/join_team_img.cd397236.png";